<script setup lang="ts">
import ElCurrencyInput from '@/components/common/ElCurrencyInput.vue'
import { PricingUnit, type PricingLine } from '@/types/asicw/pricings'
import { watch } from 'vue'

const props = defineProps<{ basePrice?: number }>()
const pricing = defineModel<PricingLine>({ required: true })

const calculateDollarsFromPercentage = () => {
  if (!pricing.value.percentageValue || !props.basePrice) {
    pricing.value.dollarValue = undefined
    return
  }
  const multiplier = pricing.value.percentageValue * 0.01
  pricing.value.dollarValue = props.basePrice * multiplier
}

const calculatePercentageFromDollars = () => {
  if (!pricing.value.dollarValue || !props.basePrice) {
    pricing.value.percentageValue = undefined
    return
  }
  const quotient = pricing.value.dollarValue / props.basePrice
  pricing.value.percentageValue = quotient * 100
}

const deriveLooseValueFromSetOne = () => {
  if (pricing.value.unit == PricingUnit.Dollars) calculatePercentageFromDollars()
  else calculateDollarsFromPercentage()
}

// Recalculate model prices when basePrice changes
watch(() => props.basePrice, deriveLooseValueFromSetOne)
</script>

<template>
  <div class="flex gap-2 w-full">
    <!-- Direct currency -->
    <ElCurrencyInput
      v-if="pricing.unit === PricingUnit.Dollars"
      v-model="pricing.dollarValue"
      :disabled="!basePrice"
      @update:model-value="calculatePercentageFromDollars"
    />

    <!-- As percentage -->
    <ElCurrencyInput
      v-if="pricing.unit === PricingUnit.Percentage"
      v-model="pricing.percentageValue"
      :precision="4"
      percentage
      :disabled="!basePrice"
      @update:model-value="calculateDollarsFromPercentage"
    />

    <el-radio-group v-model="pricing.unit" size="large" fill="var(--fill-tertiary)" :disabled="!basePrice">
      <el-radio-button label="$" :value="PricingUnit.Dollars" />
      <el-radio-button label="%" :value="PricingUnit.Percentage" />
    </el-radio-group>
  </div>
</template>
